import { JurisdictionsEnum } from '@libs/backend-common';
import { CurrencySymbol } from '@libs/types';
import { getJurisdictionBaseUrl } from './jurisdiction';
const { jurisdictionId: defaultJurId } = getJurisdictionBaseUrl();
export const getUsdOrEurCurrencySymbol = (jurisdictionId = defaultJurId) => {
    if (jurisdictionId === JurisdictionsEnum.EU) {
        return CurrencySymbol.EUR;
    }
    else {
        return CurrencySymbol.USD;
    }
};
export const getSymbolForJurisdiction = (jurisdictionId = defaultJurId) => {
    if (jurisdictionId === JurisdictionsEnum.EU) {
        return CurrencySymbol.EUR;
    }
    else {
        return CurrencySymbol.USDT;
    }
};
//# sourceMappingURL=getUsdOrEurCurrencySymbol.js.map